export const EMPLOYEE_FLOW_SLICE_NAME = "employeeData";
export const TARGET_FLOW_SLICE_NAME = "targetData";
export const REPORT_FLOW_SLICE_NAME = "report";
export const NOTIFICATION_SLICE_NAME = "notification";
export const LOADER_SLICE_NAME = "loader";
export const BEAT_FLOW_SLICE_NAME = "beat";
export const JMDO_FLOW_SLICE_NAME = "jmdoData";
export const RETAILER_MAPPING="retailerMapping"
